import axios from "axios";
import { api_variables, errorHandler,get_axios_instance, errorLogSheet } from "@/apis/variables.js";
var axios_instance_policy = get_axios_instance(api_variables.SERVICE_COMPANY_POLICY);
var axios_instance_change_password = get_axios_instance(api_variables.SERVICE_CHANGE_PASSWORD);
const API_URL = api_variables.host;
var axios_instance_create_user = get_axios_instance(api_variables.SERVICE_CREATE_USER_ACCOUNT);
var axios_instance_get_userlist = get_axios_instance(api_variables.SERVICE_GET_USER_LIST);
var axios_instance_activate_user = get_axios_instance(api_variables.SERVICE_USER_ACTIVATE);
var axios_instance_deactivate_user = get_axios_instance(api_variables.SERVICE_USER_DEACTIVATE);
var axios_instance_edit_role_permission = get_axios_instance(api_variables.SERVICE_EDIT_ROLE_PERMISSION);
//var axios_instance_forgot_password_user = get_axios_instance(api_variables.SERVICE_FORGOT_PASSWORD_USER);
var axios_instance_ess = get_axios_instance(api_variables.SERVICE_PAYLIEF_ESS);
var axios_instance_get_search_employee = get_axios_instance(api_variables.SERVICE_GET_SEARCH_EMPLOYEE)

const _pk_name = "id";

const state = {
  token: null,
  tokenObject: null,
  org_id: null,
  organisation_id: '',
  role: null,
  email: null,
  name: null,
  employeeId: null,
};

const mutations = {
  setAuthToken: (state, payload) => {
    if (payload) {
      state.token = payload.token;
      // state.name = payload.name;
    } else {
      state.token = null;
      state.name = null;
    }
  },
  setEmail: (state, payload) => {
    state.email = payload;
  },
  setNewOrgId: (state, payload) => {
    state.org_id = payload;
  },
  setOrganisationId: (state, payload) => {
    state.organisation_id = payload;
  },
  setEmployeeId: state => {
    state.employeeId = state.tokenObject ? state.tokenObject.id : null;
  },
  setOrgId: state => {
    localStorage.setItem(
      "employeeId",
      state.tokenObject ? state.tokenObject.id : null
    );
    state.name = state.tokenObject ? state.tokenObject.name : null;

    if (state.tokenObject && state.tokenObject.role[0]) {
      let orgid = state.tokenObject.role[0].org_id
        ? state.tokenObject.role[0].org_id
        : null;
      let role = state.tokenObject.role[0].role
        ? state.tokenObject.role[0].role
        : null;
      state.org_id = orgid;
      // state.role = role;
    } else {
      state.org_id = null;
      // state.role = null;
    }
  },

  setGoogleUserInfo: (state, payload) => {
    state.email = payload.email;
    state.user_id = payload.email;
    state.signInMethod = "google";
  },

  setUserRole: (state, payload) => {
    state.role = payload;
  },

  setTokenObject: (state, payload) => {
    if (payload) {
      let base64Url = payload.split(".")[1];
      let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      let jsonPayload = atob(base64);
      let tokenObj = JSON.parse(jsonPayload);
      state.tokenObject = tokenObj;
    } else {
      state.tokenObject = null;
    }
  }
};

const actions = {
  async signup({ commit }, payload) {
    try {
      let response = await axios.post(`${API_URL}/auth/signup`, payload);

      if (response.message != null) {
        throw new Error(response.message);
      }
      if (response.data.token) {
        localStorage.setItem("token-info", JSON.stringify(response.data));
        commit("setAuthToken", response.data);
      }
      return response;
    } catch (err) {
      if (err.response != null) {
        return new Error(err.response.data.message);
      } else return err;
    }
  },

  async loadFromLocalStorage({ commit }) {
    if (localStorage.getItem("token-info")) {
      const tokenInfo = JSON.parse(localStorage.getItem("token-info"));
      commit("setAuthToken", tokenInfo);
    }
  },

  async setUserRoleFromProxy({commit}, payload) {
    console.log(payload,);
    commit("setUserRole", payload);
  },

  async signinUsingPassword({ commit }, payload) {
    try {
      let data = await axios.post(`${API_URL}/auth/signin`, {
        ...payload,
        provider: "password"
      });
      if(window.localStorage.getItem("loginId") && window.localStorage.getItem("loginId") !== data.data.payload.email){
        console.log("already user is preset")
        let res = await this.act_signOut();
    // As there is no response coming from server after logout so i am checking with header response status code
       this.$emit("onSignOut", false); // PL_2904
        if (res.status == 200) {
      // Start PL_2828
       this.$router.push({
        path: "/signin",
        query: { entry_url: this.$router.currentRoute.path }
      });
      // End PL_2828
      //window.localStorage.clear();
    }
      }
      localStorage.setItem("loginId",data.data.payload.email);
      localStorage.setItem("token", data.data.payload.token);
      localStorage.setItem("userRole", data.data.payload.userRole);
      if(data.data.payload.userRole == "HR" || data.data.payload.userRole =="EMPLOYEE"){
        localStorage.setItem("le_id", data.data.payload.le_id);
        localStorage.setItem("empId", data.data.payload.employee_id);
      }
      commit("setTokenObject", data.data.payload.token);
      commit("setEmail", payload.identity);
      commit("setAuthToken", data.data.payload);
      commit("setOrgId", );
      commit("setUserRole", data.data.payload.userRole);
      if(data.data.payload.userRole == "CLIENTADMIN"){
        localStorage.setItem("empId", data.data.payload.employee_id);
        if(data.data.payload.organisations) {
          let orgId = Object.keys(data.data.payload.organisations);
          await commit("setOrganisationId", orgId[0]);
        }
      }
      commit("setEmployeeId");

      axios.defaults.headers.common["Authorization"] = data.data.payload.token;
      if (data.message != null) {
        throw Error(data.message);
      }
      return data;
    } catch (err) {
      let data = JSON.parse(localStorage.getItem("heartBeat"));
      setTimeout(() => {
        let dataAfter2Sec = JSON.parse(localStorage.getItem("heartBeat"));
         if (data.timestamp == dataAfter2Sec.timestamp) {
          window.localStorage.clear()
        }
      }, 2000)

      throw errorHandler(err.response);
    }
  },

  async verifyOTP({ commit }, payload) {
    //being used right nowxa
    try {
      let data = await axios.post(`${API_URL}/auth/verify2FA`, payload);
      localStorage.setItem("token", data.data.payload.token);
      commit("setTokenObject", data.data.payload.token);
      commit("setEmail", payload.identity);
      commit("setAuthToken", data.data.payload);
      commit("setOrgId");
      axios.defaults.headers.common["Authorization"] = data.data.payload.token;
      if (data.message != null) {
        throw Error(data.message);
      }
      return data;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async changeTheNewOrg({ commit }, payload) {
    try {
      commit("setNewOrgId", payload);
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async resendOTP({ commit }, payload) {
    try {
      let data = await axios.post(`${API_URL}/auth/resendOTP`, payload);

      if (data.message != null) {
        throw Error(data.message);
      }
      return data;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async forgotPassword({ commit }, payload) {
    try {
      let data = await axios.post(`${API_URL}/auth/setPassword`, payload);

      if (data.message != null) {
        throw Error(data.message);
      }
      return data;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async generatePassword({ commit }, payload) {
    try {
      let data = await axios.post(
        `${API_URL}/auth/generatePassword?` + "token=" + payload.token,
        payload.data
      );

      if (data.message != null) {
        throw Error(data.message);
      }
      return data;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async signInWithGoogle({ commit }, payload) {
    try {
      let response = await axios.post(`${API_URL}/auth/signin`, {
        ...payload,
        provider: "google"
      });
      if (response.message != null) {
        throw Error(response.message);
      }
      commit("setAuthToken", response.data);
      commit("setGoogleUserInfo", { email: payload.identity });
    } catch (err) {
      return err;
    }
  },
      async fetchCompanyPolicy({ commit }, payload){
          try {
            commit("setFetching", true);
            let res = await axios_instance_policy.get('/', {
              params: {
                le_id: payload.le_id,
                }
            });
            commit("setFetching", false);
            return res;
          } catch (error) {
            throw errorHandler(error.response);
          }
        

      },
      async changePassword({ commit }, payload) {
        try {
          let id = window.localStorage.getItem("loginId")
            let res = await axios_instance_change_password.post(``,{
                identity:id,
                currentPassword: payload.currentPassword,
                newPassword:payload.newPassword
              
            });
            if (res) {
               //console.log(res); 
               return res; 
              }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
  async signOut({ commit }) {
    try {
      let token = window.localStorage.getItem("token")
        ? window.localStorage.getItem("token").replace(/(^"|"$)/g, "")
        : "";

      let data = await axios.post(`${API_URL}/auth/logout?token=` + token, "");

      if (data.status) {
        commit("setAuthToken", null);
        commit("setTokenObject", null);
        commit("setEmail", null);
        commit("setOrgId");
        commit("setUserRole", null);

        localStorage.removeItem("token");
        localStorage.removeItem("vuex");
      }
      delete axios.defaults.headers.common["Authorization"];
      if (data.message != null) {
        throw Error(data.message);
      }
      return data;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async createUser({ commit }, payload) {
    try {
        //commit("setSaving", true);
        let res = await axios_instance_create_user.post('/', payload);
        //commit("setSaving", false);
        if (res.status == 200) {
          //commit("addEmployee", payload);
        }
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
  },

  async getUserList({ commit }, payload) {
    //console.log("[state/payroll/fbp/assign/fetchAll] Calling API...");
    try {
        //commit("setFetching", true);
        let res = await axios_instance_get_userlist.get(`/?limit=${payload.limit}&&offset=${payload.offset}`);
        //commit("setFetching", false);
        //console.log("[state/payroll/fbp/assign/fetchAll] res: ", res);
        if (res.status == 200) {
          //  commit("set", payload);
        }
        return res;
    } catch (err){
      //console.log(err);
    }
  },

  async getSearchedEmployee({ commit }, payload) {
    try {
      let res = await axios_instance_get_search_employee.get(`?name=${payload}`)
      return res;
    } catch(err) {
      throw err
    }
  },

  async activateUser({ commit }, payload) {
    try {
        //commit("setSaving", true);
        let res = await axios_instance_activate_user.post('/', payload);
        //commit("setSaving", false);
        if (res.status == 200) {
          //commit("addEmployee", payload);
        }
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
  },

  async deactivateUser({ commit }, payload) {
    try {
        //commit("setSaving", true);
        let res = await axios_instance_deactivate_user.post('/', payload);
        //commit("setSaving", false);
        if (res.status == 200) {
          //commit("addEmployee", payload);
        }
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
  },

  async editRolePermission({ commit }, payload) {
    try {
        //commit("setSaving", true);
        let res = await axios_instance_edit_role_permission.post('', payload, {
          params: {
            Authorization: "Bearer "+localStorage.getItem("token")
          } 
        });
        //commit("setSaving", false);
        if (res.status == 200) {
          //commit("addEmployee", payload);
        }
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
  },

  async signinUsingDwsSso({ commit }, payload) {
    try {
      let data = await axios.post(`${API_URL}/auth/createSSO`, {
        ...payload,
      });
      //console.log(data);
      if(window.localStorage.getItem("loginId") && window.localStorage.getItem("loginId") !== data.data.payload.email){
        let res = await this.act_signOut();
    // As there is no response coming from server after logout so i am checking with header response status code
       this.$emit("onSignOut", false); // PL_2904
        if (res.status == 200) {
      // Start PL_2828
       this.$router.push({
        path: "/signin",
        query: { entry_url: this.$router.currentRoute.path }
      });
      // End PL_2828
      //window.localStorage.clear();
    }
      }
      localStorage.setItem("loginId",data.data.payload.email);
      localStorage.setItem("token", data.data.payload.token);
      localStorage.setItem("userRole", data.data.payload.userRole);
      if(data.data.payload.userRole == "HR" || data.data.payload.userRole =="EMPLOYEE"){
        localStorage.setItem("le_id", data.data.payload.le_id);
        localStorage.setItem("empId", data.data.payload.employee_id);
      }
      commit("setTokenObject", data.data.payload.token);
      commit("setEmail", payload.identity);
      commit("setAuthToken", data.data.payload);
      commit("setOrgId");
      commit("setEmployeeId");
      commit("setUserRole", data.data.payload.userRole);

      axios.defaults.headers.common["Authorization"] = data.data.payload.token;
      if (data.message != null) {
        throw Error(data.message);
      }
      return data;
    } catch (err) {
      let data = JSON.parse(localStorage.getItem("heartBeat"));
      setTimeout(() => {
        let dataAfter2Sec = JSON.parse(localStorage.getItem("heartBeat"));
         if (data.timestamp == dataAfter2Sec.timestamp) {
          window.localStorage.clear()
        }
      }, 2000)
      throw errorHandler(err.response);
    }
  },

  async essSigninUsingDwsSsoSync({ commit }, payload) {
    try {
      let data = await axios_instance_ess.post(`/`, {
        ...payload,
      });
      if(window.localStorage.getItem("loginId") && window.localStorage.getItem("loginId") !== data.data.payload.email){
        console.log("already user is preset")
        let res = await this.act_signOut();
    // As there is no response coming from server after logout so i am checking with header response status code
       this.$emit("onSignOut", false); // PL_2904
        if (res.status == 200) {
      // Start PL_2828
       this.$router.push({
        path: "/signin",
        query: { entry_url: this.$router.currentRoute.path }
      });
      // End PL_2828
      //window.localStorage.clear();
    }
      }
      localStorage.setItem("loginId",data.data.payload.email);
      localStorage.setItem("token", data.data.payload.token);
      localStorage.setItem("userRole", data.data.payload.userRole);
      if(data.data.payload.userRole == "HR" || data.data.payload.userRole =="EMPLOYEE"){
        localStorage.setItem("le_id", data.data.payload.le_id);
        localStorage.setItem("empId", data.data.payload.employee_id);
      }
      
      commit("setTokenObject", data.data.payload.token);
      commit("setEmail", payload.email);
      commit("setAuthToken", data.data.payload);
      commit("setOrganisationId", data.data.payload.org_id);
      commit("setOrgId", data.data.payload.org_id);
      commit("setUserRole", data.data.payload.userRole);
      console.log('entry');
      commit("setEmployeeId");
      console.log('entry');
      axios.defaults.headers.common["Authorization"] = data.data.payload.token;
      if (data.message != null) {
        throw Error(data.message);
      }
      console.log(data);
      return data;
    } catch (err) {
      let data = JSON.parse(localStorage.getItem("heartBeat"));
      setTimeout(() => {
        let dataAfter2Sec = JSON.parse(localStorage.getItem("heartBeat"));
         if (data.timestamp == dataAfter2Sec.timestamp) {
          localStorage.clear()
          window.location.reload()
        }
      }, 2000)
      throw errorLogSheet(err.response);
    }
  },

  // async forgotPasswordUser({ commit }, payload) {
  //   try {
  //       let res = await axios_instance_forgot_password_user.post('/', payload);
  //       if (res.status == 200) {
  //         commit("addEmployee", payload);
  //       }
  //       return res;
  //   } catch (err) {
  //       throw errorHandler(err.response);
  //   }
  // },

};

let getters = {
  token: state => {
    return state.token;
  },

  isAuth: (state, getters) => {
    return getters.token != null;
  },
  userId: state => {
    return state.user_id;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
